

export default {
    name: "ClockIn",
    props: {
    },
    created() {

        let t = this;
    },
    mounted() {

        let t = this;

        if (!window.google || (window.google && !window.google.maps)) {
            let src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBmM62bnkKj7SvAsQ5X8VmsY9AZ0gAsA38&libraries=geometry,marker';
            let s = document.createElement('script');
            s.src = src;
            document.body.appendChild(s);
        }

        window.tryLocate = async () => {

            if (window.google && window.google.maps && document.getElementById("map")) {

                clearInterval(window.googleMapInterval);

                t.showClockIn = true;
                t.$forceUpdate();

                //KYORAN经纬度
                const targetLatLng = { lat: 34.992531344580755, lng: 135.76254639761083 }; // 替换为目标位置的经纬度（例如纽约）

                const targetLocation = new google.maps.LatLng(targetLatLng.lat, targetLatLng.lng);

                // 显示地图和标记
                const mapOptions = {
                    center: targetLocation,
                    zoom: 21,
                    mapId: 'beeae9f3e6e5dbbf',
                    mapTypeControl: false,      // 禁用地图类型控件
                    scaleControl: false,        // 禁用比例尺控件
                    streetViewControl: false,   // 禁用街景控件
                    rotateControl: false,       // 禁用旋转控件
                    fullscreenControl: false,   // 禁用全屏控件
                };

                const map = new google.maps.Map(document.getElementById("map"), mapOptions);

                let i = document.createElement('img');
                i.src = '/assets/img/logo-square.png';
                i.style = "width: 40px; height: 40px;position:relative;top:20px;left:0px;";
                // 添加目标位置标记
                new google.maps.marker.AdvancedMarkerElement({
                    position: targetLocation,
                    map: map,
                    title: "KYORAN",
                    content: i,
                });

                new google.maps.Circle({
                    strokeColor: "#FF0000",
                    strokeOpacity: 0.6,
                    strokeWeight: 2,
                    fillColor: "#FF0000",
                    fillOpacity: 0.2,
                    map: map,
                    center: targetLocation,
                    radius: 5, // 圆圈半径5米
                });

                async function checkProximity() {
                    if(window.Capacitor && Capacitor.Plugins.Geolocation){
                        let p = await Capacitor.Plugins.Geolocation.requestPermissions('location');
                        if(p.location == 'granted'){
                        }
                        else{
                            A.err(t.t('お使いのデバイスはGPS位置情報をサポートしていません。ブラウザの設定やシステムの権限をオンにしてから、ページを更新して再試行してください。'));
                            return;
                        }
                    }
                    if (window.Capacitor && Capacitor.Plugins.Geolocation && Capacitor.getPlatform().toLowerCase() == 'ios') {

                        window.refreshLocate = (fn) => {
                            Capacitor.Plugins.Geolocation.getCurrentPosition()
                                .then((p) => {
                                    showPosition(p);
                                    if (fn)
                                        fn();
                                })
                                .catch((err) => {
                                    A.err(t.t('お使いのデバイスはGPS位置情報をサポートしていません。ブラウザの設定やシステムの権限をオンにしてから、ページを更新して再試行してください。'));
                                    clearInterval(window.googleMapInterval);
                                });
                        };
                        window.refreshLocate();

                    }
                    else if (navigator.geolocation) {
                        window.refreshLocate = (fn) => {
                            navigator.geolocation.getCurrentPosition((p) => {
                                showPosition(p);
                                if (fn)
                                    fn();
                            }, (err) => {
                                A.err(t.t('お使いのデバイスはGPS位置情報をサポートしていません。ブラウザの設定やシステムの権限をオンにしてから、ページを更新して再試行してください。'));
                                clearInterval(window.googleMapInterval);
                            });
                        };
                        window.refreshLocate();
                    } else {
                        A.err(t.t('お使いのデバイスはGPS位置情報をサポートしていません。ブラウザの設定やシステムの権限をオンにしてから、ページを更新して再試行してください。'));
                        clearInterval(window.googleMapInterval);
                    }
                }

                function showPosition(position) {

                    const currentLatLng = new google.maps.LatLng(position.coords.latitude, position.coords.longitude);

                    t.f.lat = position.coords.latitude;
                    t.f.lng = position.coords.longitude;

                    // const currentLatLng = new google.maps.LatLng(34.992531344580755, 135.76254639761083);

                    // 计算距离（以米为单位）
                    const distance = google.maps.geometry.spherical.computeDistanceBetween(currentLatLng, targetLocation);

                    t.distance = distance;

                    t.$forceUpdate();

                    if (window.myLocationMarker) {
                        window.myLocationMarker.map = null;
                    }

                    let i = document.createElement('img');
                    i.src = '/assets/img/location.png';
                    i.style = "width: 40px; height: 40px;position:relative;top:0px;left:0px;";

                    window.myLocationMarker = new google.maps.marker.AdvancedMarkerElement({
                        position: currentLatLng,
                        map: map,
                        title: "MY LOCATION",
                        content: i,
                    });
                }

                checkProximity();
            }
        }

        window.googleMapInterval = setInterval(() => {
            window.tryLocate();
        }, 100);

        t.loadData();
    },
    activated() {
    },
    deactivated() {
    },
    methods: {
        loadData() {
            let t = this;

            axios.post('clockIn/getToday').then(res => {
                if (res.data.status == 1) {

                    let items = res.data.options.items;

                    if (items.length > 0) {

                        let toRemove = [];

                        let dict = {};

                        items.forEach(clockData => {
                            if (!dict[clockData.type]) {
                                dict[clockData.type] = clockData;
                            }
                            else {
                                if (clockData.sup_id && !dict[clockData.type].sup_id) {
                                    toRemove.push(dict[clockData.type]);
                                }
                                else if (!clockData.sup_id && dict[clockData.type].sup_id) {
                                    toRemove.push(clockData);
                                }
                                else if (clockData.sup_id && dict[clockData.type].sup_id) {

                                    if (clockData.sup_id > dict[clockData.type].sup_id) {
                                        toRemove.push(dict[clockData.type]);
                                    }
                                    else {
                                        toRemove.push(clockData);
                                    }
                                }
                            }
                        });

                        toRemove.forEach(_item => {
                            items.remove(_item);
                        });

                        items.forEach(clockData => {
                            if (clockData.type == 1) {
                                t.clockData_start = clockData;
                                t.clockIn_start = clockData.time;
                            }
                            else if (clockData.type == 2) {
                                t.clockData_end = clockData;
                                t.clockIn_end = clockData.time;
                            }
                        });
                    }

                    if (res.data.options.field_works && res.data.options.field_works.length > 0) {

                        let fieldWorks = res.data.options.field_works;

                        fieldWorks.forEach(fieldWork => {
                            if (fieldWork) {
                                if (fieldWork.clock_in == 1 && fieldWork.clock_out == 1) {
                                    t.fieldWork = fieldWork;
                                }
                                else if (fieldWork.clock_in == 1) {
                                    t.fieldWorkIn = fieldWork;
                                }
                                else if (fieldWork.clock_out == 1) {
                                    t.fieldWorkOut = fieldWork;
                                }
                            }
                        });
                    }

                    t.schedule = res.data.options.schedule;

                    // if (res.data.options.att_config) {
                    //     t.attConfig = res.data.options.att_config;
                    // }

                    t.applySchedule(t.schedule, res.data.options.yesterday_items);
                    t.ready = true;
                }
            });
        },

        applySchedule(schedule, yesterday_items) {

            let yesterdayDict = {};
            let dict = {};

            let t = this;

            if (yesterday_items && yesterday_items.length > 0) {

                let toRemove = [];

                yesterday_items.forEach(clockData => {
                    if (!yesterdayDict[clockData.type]) {
                        yesterdayDict[clockData.type] = clockData;
                    }
                    else {
                        if (clockData.sup_id && !yesterdayDict[clockData.type].sup_id) {
                            toRemove.push(yesterdayDict[clockData.type]);
                        }
                        else if (!clockData.sup_id && yesterdayDict[clockData.type].sup_id) {
                            toRemove.push(clockData);
                        }
                        else if (clockData.sup_id && yesterdayDict[clockData.type].sup_id) {
                            if (clockData.sup_id > yesterdayDict[clockData.type].sup_id) {
                                toRemove.push(yesterdayDict[clockData.type]);
                            }
                            else {
                                toRemove.push(clockData);
                            }
                        }
                    }
                });

                toRemove.forEach(_item => {
                    yesterday_items.remove(_item);
                });

                yesterday_items.forEach(clockData => {
                    yesterdayDict[clockData.type] = clockData;
                });
            }

            if (schedule) {

                for (const key in schedule) {
                    dict[schedule[key].date] = schedule[key];
                }

                let now = new Date();
                let startTime = null;
                let endTime = null;
                let go = true;

                // let today = now.format('yyyy-MM-dd');
                // let todayData = dict[today];
                // if (todayData && (todayData.work == 1 || todayData.work == 2)) {

                //     startTime = new Date(todayData.date + ' ' + todayData.start_time + ':00');
                //     endTime = new Date(todayData.date + ' ' + todayData.end_time + ':00');

                //     if (todayData.tomorrow == 1) {
                //         endTime.setDate(endTime.getDate() + 1);
                //     }
                //     else if (todayData.tomorrow == 2) {
                //         startTime.setDate(endTime.getDate() + 1);
                //         endTime.setDate(endTime.getDate() + 1);
                //     }

                //     startTime.setHours(startTime.getHours() - 1);
                //     endTime.setHours(endTime.getHours() + 13);

                //     if (now >= startTime && now <= endTime) {
                //         go = false;
                //     }
                //     else {
                //     }
                // }

                let yesterday = new Date(now.format('yyyy-MM-dd'));
                yesterday.setDate(yesterday.getDate() - 1);

                let yesterdayData = dict[yesterday.format('yyyy-MM-dd')];

                if (yesterdayData && (yesterdayData.work == 1 || yesterdayData.work == 2) && go) {

                    startTime = new Date(yesterdayData.date + ' ' + yesterdayData.start_time + ':00');
                    endTime = new Date(yesterdayData.date + ' ' + yesterdayData.end_time + ':00');

                    if (yesterdayData.tomorrow == 1) {
                        endTime.setDate(endTime.getDate() + 1);
                    }
                    else if (yesterdayData.tomorrow == 2) {
                        startTime.setDate(endTime.getDate() + 1);
                        endTime.setDate(endTime.getDate() + 1);
                    }

                    startTime.setHours(startTime.getHours() - 1);
                    endTime.setHours(endTime.getHours() + 13);

                    if (now >= startTime && now <= endTime) {
                        go = false;
                        if (yesterdayDict[1]) {
                            t.clockIn_start = yesterdayDict[1].time;
                            t.clockData_start = yesterdayDict[1];
                            t.clockData_start.day = 1;
                        }
                    } else {
                    }
                }

                let tomorrow = new Date(now.format('yyyy-MM-dd'));
                tomorrow.setDate(tomorrow.getDate() + 1);

                let tomorrowData = dict[tomorrow.format('yyyy-MM-dd')];
                if (tomorrowData && (tomorrowData.work == 1 || tomorrowData.work == 2) && go) {

                    startTime = new Date(tomorrowData.date + ' ' + tomorrowData.start_time + ':00');
                    endTime = new Date(tomorrowData.date + ' ' + tomorrowData.end_time + ':00');

                    if (tomorrowData.tomorrow == 1) {
                        endTime.setDate(endTime.getDate() + 1);
                    }
                    else if (tomorrowData.tomorrow == 2) {
                        startTime.setDate(endTime.getDate() + 1);
                        endTime.setDate(endTime.getDate() + 1);
                    }

                    startTime.setHours(startTime.getHours() - 1);
                    endTime.setHours(endTime.getHours() + 13);

                    if (now >= startTime && now <= endTime) {
                        t.clockData_start = null;
                        t.clockData_end = null;
                        t.clockIn_start = null;
                        t.clockIn_end = null;
                    }
                    else {
                    }
                }

            }
        },

        clockIn() {

            let t = this;

            if (t.busying)
                return;

            t.busying = true;

            window.refreshLocate(() => {

                let ignoreLocaiton = false;

                if (/localhost/.test(location.host)) {
                    ignoreLocaiton = true;
                }

                if (t.fieldWork && (t.fieldWork.status == 1 || t.fieldWork.is_today == 1)) {
                    if (t.fieldWork.clock_in == 1) {
                        if (!t.clockIn_start)
                            ignoreLocaiton = true;
                    }
                    if (t.fieldWork.clock_out == 1) {
                        if (t.clockIn_start)
                            ignoreLocaiton = true;
                    }
                }

                if (t.fieldWorkIn) {
                    if (!t.clockIn_start)
                        ignoreLocaiton = true;
                }


                if (t.fieldWorkOut) {
                    if (t.clockIn_start && !t.clockIn_end)
                        ignoreLocaiton = true;
                }

                if (t.schedule && t.schedule.today && t.schedule.today.work == 2) {
                    ignoreLocaiton = true;
                }

                if (!ignoreLocaiton) {
                    if (t.distance == -1) {
                        A.err(t.t('GPSの位置情報を取得した後で出勤打刻を行ってください。'));
                        return;
                    }

                    if (t.distance > 50) {
                        A.err(t.t('現在の位置がKYORANから離れています。赤い円の範囲内（50メートル）に入ってから再試行してください。'));
                        return;
                    }
                }

                axios.post('clockIn/clockInByPos', t.f).then(res => {

                    t.busying = false;

                    if (res.data.status == 1) {

                        if (res.data.options.item.type == 1)
                            t.clockIn_start = res.data.options.item.time;
                        else if (res.data.options.item.type == 2)
                            t.clockIn_end = res.data.options.item.time;

                        A.toast('完了!');

                    }
                    else {
                        A.err('出勤打刻は' + t.clockIn_start + 'であり，<br>15分後まで退勤打刻はできません。');
                    }
                });

            });


        },

        submitFieldWork() {
            let t = this;

            if (t.busying) return;

            t.f2.date = Date.today().format('yyyy/MM/dd');

            t.f2.is_today = 1;

            if (t.f2.clock_in && !t.f2.clock_in_description) {
                A.err(t.t("直行場所と理由を述べてください。"));
                return;
            }

            if (t.f2.clock_out && !t.f2.clock_out_description) {
                A.err(t.t("直帰場所と理由を述べてください。"));
                return;
            }

            t.busying = true;

            axios.post("clockIn/submitFieldWork", t.f2).then((res) => {

                t.busying = false;

                t.f2 = {
                    clock_in: false,
                    clock_out: false,
                    clock_in_description: "",
                    clock_out_description: "",
                    date: "",
                    is_today: 1
                };

                if (res.data.status == 1) {
                    t.showFieldWorkEditor = false;
                    let item = res.data.options.item;
                    if (item.clock_in == 1 && item.clock_out == 1) {
                        t.fieldWork = item;
                    }
                    else if (item.clock_in == 1) {
                        t.fieldWorkIn = item;
                    }
                    else if (item.clock_out == 1) {
                        t.fieldWorkOut = item;
                    }
                } else if (res.data.status == 2) {
                    A.err(
                        "The number of field work applications for this month has been exhausted."
                    );
                } else if (res.data.status == 3) {
                    A.err(
                        "A field work application for the day has already been submitted."
                    );
                }
            });
        },

        cancelFieldWork(fieldWork, key) {
            let t = this;

            A.safety("この申請をキャンセルしてもよろしいですか？").then(
                (res) => {
                    if (res.isConfirmed) {
                        axios
                            .post("clockIn/cancelFieldWork/" + fieldWork.id)
                            .then((res) => {
                                if (res.data.status == 1) {
                                    t[key] = null;
                                    t.showFieldWorkEditor = false;
                                }
                            });
                    }
                }
            );
        },

        showFieldWorkHint() {
            A.show('本日は直行直帰の状態ですので、会社の近くにいなくても打刻が可能です。', '', 'info');
        }
    },
    data() {
        return {
            showFieldWorkEditor: false,
            ready: false,
            busying: false,
            clockData_start: null,
            clockData_end: null,
            clockIn_start: null,
            clockIn_end: null,
            distance: -1,
            showClockIn: false,
            fieldWork: null,
            fieldWorkIn: null,
            fieldWorkOut: null,
            // attConfig: null,
            schedule: {},
            f: {
                lat: '',
                lng: ''
            },
            f2: {
                clock_in: false,
                clock_out: false,
                clock_in_description: "",
                clock_out_description: "",
                date: "",
                is_today: 1
            },
        };
    },
};

